{
  "version": 1,
  "asset_id": "4a79c82a-14e6-4386-8820-fff412697daf",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/4a79c82a-14e6-4386-8820-fff412697daf/wagenpark-vakkundig.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/4a79c82a-14e6-4386-8820-fff412697daf/wagenpark-vakkundig.jpg",
  "original_filename": "wagenpark-vakkundig.jpg",
  "size": 102295,
  "content_type": "image/jpeg",
  "created_at": "2026-08-31T19:20:56Z"
}
